import axios from "axios";

const apiV2 = axios.create({
  baseURL: process.env.REACT_APP_API_URL_V2,
});

export default apiV2;
